import { useGlobalData } from "@/context/global";
import MegaMenu from "../mega-menu/MegaMenu";
import CategoriesDropdown from "./CategoriesDropdown";
import { useEffect } from "react";
import { useSlugs } from "@/context/categoryTree";
import { generateSlugs } from "@/utils/category";

const Categories = () => {
  const {
    appData: { megaMenuTreeData },
  } = useGlobalData();
  const { setSlugs } = useSlugs();
  useEffect(() => {
    const slugs = generateSlugs(megaMenuTreeData);
    setSlugs(slugs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [megaMenuTreeData]);

  return (
    <div className="bg-[#F6F6F6] px-4 hidden lg:block shadow-categories border-b">
      <div className="flex items-center w-11/12 gap-12 mx-auto ">
        <CategoriesDropdown menuTreeData={megaMenuTreeData} />

        <MegaMenu megaMenuTreeData={megaMenuTreeData} />
      </div>
    </div>
  );
};

export default Categories;
